import { createBrowserRouter } from 'react-router-dom';
import App from '../App.jsx';
import InvestPro from '../pages/InvestPro/InvestPro.jsx';

const routes = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [{ path: '/invest-pro', element: <InvestPro /> }],
  },
]);

export default routes;
